import { Button, Input, Select, SelectOption, ToggleSwitch } from '@youseedk/dna-react';
import { HandlerSetting, handlers } from 'mocks/handlers';
import { MockedRequest, RestHandler } from 'msw';
import React, { useState } from 'react';
import { useStorage } from 'shared/hooks/useStorage';
import { local } from 'shared/utils/storage/local-storage';

const resetAll = () => {
  for (const handler of handlers) {
    local.remove(`mocksetting_${handler.info.path}`);
  }
  local.remove('mocksetting_impersonation');
};

export const MockSettings = () => {
  const [search, setSearch] = useState('');

  return (
    <>
      <div className='navpanel__item-link'>
        <Input label='Filter' onChange={(e) => setSearch(e.value.toLowerCase())} />
      </div>
      <Button position='CENTERED' variant='TERTIARY' noDefaultMargin onClick={resetAll}>
        Reset all settings
      </Button>
      {'impersonation tool active'.includes(search) && <ImpersonationToggle />}
      {handlers
        .sort((a, b) => (a.info.path > b.info.path ? 1 : b.info.path > a.info.path ? -1 : 0))
        .filter((handler) => (handler.info.path as string).toLowerCase().includes(search))
        .map((handler, index) => (
          <MockHandlerSetting handler={handler} key={'mockhandler_' + index} />
        ))}
    </>
  );
};
const ImpersonationToggle = () => {
  const [isOn, setIsOn] = useStorage<boolean>(`mocksetting_impersonation`, true, false);
  return (
    <div className='navpanel__item-link'>
      <ToggleSwitch
        checked={Boolean(isOn)}
        onChange={(e) => {
          setIsOn(e.value);
          window.location.reload();
        }}
        label='Impersonation Tool Active'
      />
    </div>
  );
};

const MockHandlerSetting = ({ handler }: { handler: RestHandler<MockedRequest> }) => {
  const [handlerSetting, setHandlerSetting] = useStorage<HandlerSetting>(
    `mocksetting_${handler.info.path}`,
    true,
    'mock',
  );

  const path = handler.info.path as string;
  const pathName = path.startsWith('http')
    ? new URL(handler.info.path as string).pathname
    : handler.info.path?.toString();

  return (
    <div className='navpanel__item-link' title={handler.info.path as string}>
      <span title={`${pathName}`}>{pathName}</span>
      <Select
        value={handlerSetting || 'mock'}
        onChange={(e) => {
          setHandlerSetting(e.value as HandlerSetting);
        }}>
        <SelectOption value='mock'>Mock data</SelectOption>
        <SelectOption value='array'>Empty array</SelectOption>
        <SelectOption value='object'>Empty object</SelectOption>
        <SelectOption value='fail'>Fail</SelectOption>
        <SelectOption value='original'>Real request</SelectOption>
      </Select>
    </div>
  );
};
